import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { RoutingHistoryService } from 'src/app/shared/components/services/routing-history.service';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrls: ['./marketplace-wallet-page.component.scss'],
})
export class MarketplaceWalletPageComponent implements OnInit {
  mobileTitle: string = '';
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private rewardWalletService: RewardsWalletService,
    private cd: ChangeDetectorRef,
    private routeHistory: RoutingHistoryService
  ) {}
  id: string;
  ngOnInit() {
    firstValueFrom(this.rewardWalletService.fetchWalletItems());
    this.id = this.route.snapshot.paramMap.get('id') || '0';
  }
  ngAfterViewInit(): void {
    this._getMobileTitle(this.routeHistory.getPreviousUrl() || '');
  }

  private _getMobileTitle(url: string): void {
    this.mobileTitle = url?.toLowerCase().includes('claimed') ? 'wallet.redeemed.title' : 'wallet.page.title';
    this.cd.detectChanges();
  }
  back(): void {
    this.location.back();
  }
}
